import { api } from "./client";
import type {
  EmergencyConfirmationRequest,
  EmergencyConfirmationResponse,
  GlobalConfigInput,
  GlobalConfigVersion,
} from "./types";

/** docs/API_CONTRACT.md - GET /api/admin/config/current */
export function getCurrentConfig(): Promise<GlobalConfigVersion> {
  return api.get<GlobalConfigVersion>("/admin/config/current");
}

/** docs/API_CONTRACT.md - PUT /api/admin/config */
export function updateConfig(payload: GlobalConfigInput): Promise<GlobalConfigVersion> {
  return api.put<GlobalConfigVersion>("/admin/config", payload);
}

/** POST /api/admin/emergency-confirmations */
export function createEmergencyConfirmation(
  payload: EmergencyConfirmationRequest,
): Promise<EmergencyConfirmationResponse> {
  return api.post<EmergencyConfirmationResponse>("/admin/emergency-confirmations", payload);
}

/** docs/API_CONTRACT.md - GET /api/admin/config/versions */
export function listConfigVersions(): Promise<GlobalConfigVersion[]> {
  return api.get<GlobalConfigVersion[]>("/admin/config/versions");
}

/** docs/API_CONTRACT.md - GET /api/admin/config/versions/{versionId} */
export function getConfigVersion(versionId: string): Promise<GlobalConfigVersion> {
  return api.get<GlobalConfigVersion>(
    `/admin/config/versions/${encodeURIComponent(versionId)}`,
  );
}

/** docs/API_CONTRACT.md - POST /api/admin/config/versions/{versionId}/rollback */
export function rollbackConfigVersion(versionId: string): Promise<GlobalConfigVersion> {
  return api.post<GlobalConfigVersion>(
    `/admin/config/versions/${encodeURIComponent(versionId)}/rollback`,
  );
}
